module.exports = __webpack_public_path__ + "img/loading.3d7eb857.svg";